import React from 'react';
import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';
import { Card } from '../../ui/Card';
import { DetailField } from './DetailField';
import { formatCourseDate, getTrainedCourses, productLabel, venueLabel } from '../../../utils/trainingCourses';
import { TrainingCourse } from '../../../types/trainingCourse';
interface CourseInfoCardProps {
  course: TrainingCourse;
  courses: TrainingCourse[];
}
export function CourseInfoCard({
  course,
  courses
}: CourseInfoCardProps) {
  const lead = course.leadCourseId ? courses.find(c => c.id === course.leadCourseId) : undefined;
  const trained = getTrainedCourses(courses, course.id);
  const isOnDemand = course.status === 'ondemand';
  return <Card title="Dati corso" noHoverShadow data-id="element-1142" data-mp="hnvf83dyllwa">
      <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5" data-id="element-1143" data-mp="1e69i4x0i86pr">
        <DetailField label="Tipologia di corso + codice prodotto" full data-id="element-1144" data-mp="1e7ko93hf9qk1">
          {productLabel(course.productCode)}
        </DetailField>
        <DetailField label="Codice specifico del corso" data-id="element-1145" data-mp="38625y02ldo7k">
          <span className="font-mono" data-id="element-1146" data-mp="386kbjnb59es5">{course.courseCode}</span>
        </DetailField>
        <DetailField label="Acquisto prodotto esterno" data-id="element-1147" data-mp="3d4c6yrazzj13">
          {course.externalProduct ? 'Sì' : 'No'}
        </DetailField>
        <DetailField label="Data inizio corso" data-id="element-1148" data-mp="2ye4vwwnbl2af">
          {formatCourseDate(course.startDate)}
        </DetailField>
        <DetailField label="Data fine corso" data-id="element-1149" data-mp="2pfkjgd8croun">
          {formatCourseDate(course.endDate)}
        </DetailField>
        <DetailField label="Caratteristica del corso" data-id="element-1150" data-mp="2uex6oz34yxxr">
          {course.characteristic}
        </DetailField>
        {course.characteristic === 'Trainato' && <DetailField label="Corso trainante" data-id="element-1151" data-mp="2fj7olc12n4yb">
            {lead ? <Link to={`/training/corsi/${lead.id}`} className="text-seform-orange hover:underline" data-id="element-1152" data-mp="2kgq1tem4g6c4">
                {lead.courseCode} — {lead.name}
              </Link> : 'Nessun corso collegato'}
          </DetailField>}
        {!isOnDemand && <>
            <DetailField label="Commessa" data-id="element-1153" data-mp="c81pfs6b2be9">
              {course.commission === 'SEFORM' ? 'Commessa SEFORM' : `Commessa cliente — ${course.clientName || '-'}`}
            </DetailField>
            <DetailField label="Sede" data-id="element-1154" data-mp="38y5klzbdryp">{venueLabel(course.venue)}</DetailField>
            {course.venue === 'cliente' && <DetailField label="Sede del cliente" full data-id="element-1155" data-mp="zxdvwka905cv">
                {course.clientSite}
              </DetailField>}
          </>}
      </dl>

      {course.characteristic === 'Trainante' && <div className="mt-6 pt-5 border-t border-slate-100" data-id="element-1156" data-mp="q5zprtnsk7ar">
          <p className="text-sm font-medium text-seform-navy flex items-center gap-2 mb-2" data-id="element-1157" data-mp="m5zdaek9666c">
            <Link2 className="h-4 w-4" data-id="element-1158" data-mp="1ipghma1qybtz" /> Corsi trainati
          </p>
          {trained.length > 0 ? <ul className="space-y-1.5" data-id="element-1159" data-mp="1dx576d9dr7n6">
              {trained.map(c => <li key={c.id} className="text-sm" data-id="element-1160" data-mp="2wlgc49cr0bcj">
                  <Link to={`/training/corsi/${c.id}`} className="text-slate-700 hover:text-seform-orange" data-id="element-1161" data-mp="2wn19e6qg68e3">
                    <span className="font-mono text-xs text-slate-500 mr-2" data-id="element-1162" data-mp="35jtgm9ad2f0j">
                      {c.courseCode}
                    </span>
                    {c.name}
                  </Link>
                </li>)}
            </ul> : <p className="text-sm text-slate-500" data-id="element-1163" data-mp="3ki3xudlca9u1">
              Nessun corso trainato collegato.
            </p>}
        </div>}
    </Card>;
}